/**
 * ProductCard - product preview card used in grids and carousels.
 * Custom element: <product-card>
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import "./vendor.js";
class ProductCard extends ThemeComponent {
  init() {}
}
setFunctionName(ProductCard, "ProductCard");
const propertyTypes = {};
ProductCard.prototype.$name = "ProductCard";
ProductCard.prototype.$info = JSON.parse('{"name":"ProductCard","meta":{"isLegacy":false,"selector":"product-card"},"props":[],"refs":[]}');
ProductCard.prototype.$info.component = ProductCard;
for (const prop of ProductCard.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("Product/ProductCard.ts", {
  ProductCard: ProductCard
}, void 0);